import React, { memo } from "react";
import KPIGroup from "./KPIGroup";

const KPIRow = ({ rowData, ...otherProps }) => {
  return rowData.map((eachGroup, index) => {
    return (
      <KPIGroup
        key={eachGroup.kpiGroup}
        kpiGroupData={eachGroup}
        index={index}
        {...otherProps}
      />
    );
  });
};

export default memo(KPIRow);
